import { render } from "./ProjectUpdateBanner.vue?vue&type=template&id=26d5f922"
import script from "./ProjectUpdateBanner.vue?vue&type=script&lang=js"
export * from "./ProjectUpdateBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__